<!-- 陪练背景 -->
<template>
  <el-scrollbar class="practice-background">
    <div class="practice-background__container">
      <!-- 人物 -->
      <div class="practice-background__person">
        <div class="practice-background__person--avatar">
          <img alt="avatar" :src="avatar" />
        </div>
        <div class="practice-background__person--name">{{ customerName }}</div>
        <div v-if="customerProfile" class="practice-background__person--profile">
          {{ customerProfile }}
        </div>
      </div>
      <!-- 客户画像 -->
      <div class="practice-background__card">
        <!-- <div class="card-header"> -->
        <!-- <div v-if="topicTitle" class="card-header__title">{{ topicTitle }}</div> -->
        <!-- <div v-if="backgroundText" class="card-header__desc">{{ backgroundText }}</div> -->
        <!-- </div> -->

        <!-- 陪练内容 -->
        <div v-if="showPracticeContentCard" class="info-block">
          <div class="info-block__title">陪练内容</div>
          <p v-if="practiceTopicDescText" class="info-block__desc">
            {{ practiceTopicDescText }}
          </p>
          <div v-for="field in practiceContentFields" :key="field.key" class="field-item">
            <div class="field-item__label">{{ field.title }}</div>
            <div class="field-item__value">
              <p
                v-for="(line, lineIndex) in field.lines"
                :key="`${field.key}-${lineIndex}`"
                class="field-item__text"
              >
                {{ line }}
              </p>
            </div>
          </div>
        </div>

        <!-- 客户信息 -->
        <div v-if="customerInfoFields.length" class="info-block">
          <div class="info-block__title">客户信息</div>
          <div v-for="field in customerInfoFields" :key="field.key" class="field-item">
            <div class="field-item__label">{{ field.title }}</div>
            <div class="field-item__value">
              <p
                v-for="(line, lineIndex) in field.lines"
                :key="`${field.key}-${lineIndex}`"
                class="field-item__text"
              >
                {{ line }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script setup>
import { computed, defineOptions } from 'vue'
import avatar from '@/assets/ai-avatar/ai-practice-partner-man.png'

defineOptions({
  name: 'PracticeBackground'
})

const props = defineProps({
  // 陪练介绍内容，来自开始陪练接口返回的 practiceContent
  practiceContent: {
    type: Object,
    default: () => ({})
  },
  // 任务名，作为客户画像卡标题兜底
  taskName: {
    type: String,
    default: ''
  }
})

const formatFieldLines = (value) => {
  const sourceList = Array.isArray(value) ? value : [value]
  return sourceList
    .flatMap((item) => String(item ?? '').split('\n'))
    .map((item) => item.trim())
    .filter(Boolean)
}

const formatText = (value) => formatFieldLines(value).join('\n')

// const topicTitle = computed(() => props.practiceContent?.practiceTopic || props.taskName || '')

// const backgroundText = computed(() => formatText(props.practiceContent?.background))

const customerInfoFields = computed(() =>
  [
    {
      key: 'customerChat',
      title: '客户原话',
      lines: formatFieldLines(props.practiceContent?.customerChat)
    },
    {
      key: 'initialAttitude',
      title: '客户初始态度',
      lines: formatFieldLines(props.practiceContent?.initialAttitude)
    }
  ].filter((field) => field.lines.length)
)

const practiceTopicDescText = computed(() => formatText(props.practiceContent?.practiceTopicDesc))

const practiceContentFields = computed(() =>
  [
    {
      key: 'background',
      title: '场景描述',
      lines: formatFieldLines(props.practiceContent?.background)
    },
    {
      key: 'trainingGoal',
      title: '训练目标',
      lines: formatFieldLines(props.practiceContent?.trainingGoal)
    }
  ].filter((field) => field.lines.length)
)

const showPracticeContentCard = computed(
  () => !!practiceTopicDescText.value || practiceContentFields.value.length > 0
)

const customerName = computed(() => props.practiceContent?.customerName || '张经理')
const customerProfile = computed(() => props.practiceContent?.customerProfile || '')
</script>

<style lang="less" scoped>
.practice-background {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  // overflow: auto;
  padding: 12px;

  // &::-webkit-scrollbar {
  //   display: none;
  // }

  &__container {
    display: flex;
    flex-direction: column;
  }

  &__person {
    width: 100%;
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &--avatar {
      width: 128px;
      height: 128px;

      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        -webkit-mask-image: linear-gradient(180deg, #000000 0%, #000000 76%, transparent 100%);
        mask-image: linear-gradient(180deg, #000000 0%, #000000 76%, transparent 100%);
      }
    }

    &--name {
      margin-top: 4px;
      color: #323233;
      margin-top: 12px;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }

    &--profile {
      margin-top: 4px;
      max-width: 95%;
      box-sizing: border-box;
      color: #969799;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  &__card {
    margin-top: 16px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 16px;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;

    > * + * {
      margin-top: 16px;
    }

    .card-header {
      display: flex;
      flex-direction: column;

      > * + * {
        margin-top: 8px;
      }

      &__title {
        color: #323233;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }

      &__desc {
        color: #646566;
        font-size: 14px;
        line-height: 20px;
        white-space: pre-wrap;
      }
    }

    .info-block {
      box-sizing: border-box;
      background: #f7f8fa;
      border: 1px solid #e5e6eb;
      border-radius: 16px;
      padding: 12px;
      display: flex;
      flex-direction: column;

      > * + * {
        margin-top: 8px;
      }

      &__title {
        position: relative;
        padding-left: 12px;
        color: #323233;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;

        &::before {
          content: '';
          position: absolute;
          top: 3px;
          left: 0;
          width: 4px;
          height: 14px;
          border-radius: 4px;
          background: #7a52f4;
        }
      }

      &__desc {
        margin: 0;
        color: #646566;
        font-size: 13px;
        line-height: 20px;
        white-space: pre-wrap;
      }
    }
  }

  .field-item {
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 12px;
    padding: 8px 12px;

    &__label {
      color: #323233;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
    }

    &__value {
      margin-top: 4px;
    }

    &__text {
      margin: 0;
      color: #646566;
      font-size: 13px;
      line-height: 18px;
      white-space: pre-wrap;
    }

    &__text + &__text {
      margin-top: 4px;
    }
  }
}
</style>
